const state = {
    mobilDisplay: false,
}
const getters = {
    isMobil(state) {
        return state.mobilDisplay;
    }
}
const mutations = {
    setMobil(state, payload) {
        state.mobilDisplay = payload;
    }
}
export default {
    state,
    mutations,
    getters
}